import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicket } from "@fortawesome/free-solid-svg-icons";

export default function ViewDetails() {
  const [data, setData] = useState([]);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const handleClick = (row) => {
  //console.log(allUserData);
  
  // Open new tab
  window.open("", "_blank");
};
  useEffect(() => {
    const payload = JSON.parse(localStorage.getItem("viewPayload"));
    if (!payload) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          // `${process.env.REACT_APP_API_BASE_URL}/emp/tickets`,
          `https://api.autotronicsuk.com/api/emp/tickets`,
          payload
        );

        const tickets = Array.isArray(response.data.tickets)
          ? response.data.tickets
          : response.data.tickets
          ? [response.data.tickets]
          : [];

        setData(tickets);
        setUser(response.data.userDetails && response.data.userDetails[0] ? response.data.userDetails[0] : {});
      } catch (error) {
        console.error("API Error:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Derived pagination values
  const totalPages = Math.max(1, Math.ceil(data.length / recordsPerPage));
  const paginatedData = data.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  // clamp currentPage when data or recordsPerPage change
  useEffect(() => {
    const newTotal = Math.max(1, Math.ceil(data.length / recordsPerPage));
    setCurrentPage((p) => Math.min(p, newTotal));
  }, [data.length, recordsPerPage]);

  // helper to compute page items with ellipsis
  const getPageItems = (total, current, maxButtons = 7) => {
    if (total <= maxButtons) return Array.from({ length: total }, (_, i) => i + 1);

    const pages = [];
    const middle = Math.floor((maxButtons - 3) / 2); // reserve first, last, and possible two ellipses
    let start = Math.max(2, current - middle);
    let end = Math.min(total - 1, current + middle);

    // adjust when near edges
    if (current - 1 <= middle) {
      start = 2;
      end = maxButtons - 2;
    } else if (total - current <= middle) {
      start = total - (maxButtons - 3);
      end = total - 1;
    }

    pages.push(1);
    if (start > 2) pages.push("left-ellipsis");
    for (let p = start; p <= end; p++) pages.push(p);
    if (end < total - 1) pages.push("right-ellipsis");
    pages.push(total);
    return pages;
  };

  const scrollToTableTop = () => {
    const el = document.querySelector(".card.p-3.position-relative");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const onSetPage = (page) => {
    setCurrentPage(page);
    scrollToTableTop();
  };

  // Helpers: determine ticket value for a row (tries common keys)
  const getTicketValue = (row) =>
    row.ticket ||
    row.ticket_no ||
    row.ticket_id ||
    row.Ticket ||
    row.id ||
    row.ticketNumber ||
    "";

  return (
    <div className="container mt-4">
      {/* User Information Section */}
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="fw-bold mb-3">Employee Information</h4>

          <div className="row">
            <div className="col-md-4">
              <p>
                <strong>Name:</strong> {user.u_name || "-"}
              </p>
            </div>
            <div className="col-md-4">
              <p>
                <strong>EmployeeId:</strong> {user.empid || "-"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Ticket Details Section */}
      <h3 className="mb-3 fw-bold">Ticket Details</h3>

      <div className="card p-3 position-relative">
        {/* Loader overlay */}
        {loading && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{ background: "rgba(255,255,255,0.8)", zIndex: 2000 }}
          >
            <div className="spinner-border text-primary" role="status" aria-hidden="true">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {!loading && data.length === 0 && <p className="mb-0">No records found.</p>}

        {!loading && data.length > 0 && (
          <>
            {/* scrollable grid: vertical + horizontal */}
            <div className="table-scroll">
              <table className="table table-bordered table-striped mb-0">
                <thead className="table-dark">
                  <tr>
                    {Object.keys(data[0]).map((col, index) => (
                      <th key={index}>
                        {col.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                      </th>
                    ))}
                    {/* additional Ticket column */}
                    <th>
                      TICKET
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {Object.keys(row).map((col, colIndex) => (
                        <td key={colIndex}>{row[col]}</td>
                      ))}
                      <td>
                        <button
                             className="btn btn-sm btn-primary"
                            onClick={() => {
                            // prefer ticket id fields if available, otherwise fallback to sample id
                            const ticketId = row?.st_number || row?.ticket_id || '534888';
                            const url = `https://autotronics.repairshopr.com/search?search[query]=${ticketId}`;
                            console.log("Opening URL:", url);
                            window.open(url, '_blank', 'noopener,noreferrer');
                          }}
                           >
                             <FontAwesomeIcon icon={faTicket} />
                           </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination + rows-per-page selector */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <nav aria-label="Table pagination">
                <ul className="pagination mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onSetPage(Math.max(1, currentPage - 1))}>
                      Prev
                    </button>
                  </li>

                  {getPageItems(totalPages, currentPage).map((item, idx) => {
                    if (item === "left-ellipsis" || item === "right-ellipsis") {
                      return (
                        <li key={item + idx} className="page-item disabled">
                          <span className="page-link">…</span>
                        </li>
                      );
                    }
                    return (
                      <li key={item} className={`page-item ${currentPage === item ? "active" : ""}`}>
                        <button className="page-link" onClick={() => onSetPage(item)}>
                          {item}
                        </button>
                      </li>
                    );
                  })}

                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onSetPage(Math.min(totalPages, currentPage + 1))}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>

              <div className="d-flex align-items-center gap-2">
                <label className="small text-muted mb-0">Rows</label>
                <select
                  className="form-select form-select-sm"
                  value={recordsPerPage}
                  onChange={(e) => {
                    const val = Number(e.target.value);
                    setRecordsPerPage(val);
                    setCurrentPage(1);
                    scrollToTableTop();
                  }}
                  style={{ width: 100 }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                </select>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
